import { render, staticRenderFns } from "./CopySupperDialog.vue?vue&type=template&id=15379bf5&scoped=true&"
import script from "./CopySupperDialog.vue?vue&type=script&lang=ts&"
export * from "./CopySupperDialog.vue?vue&type=script&lang=ts&"
import style0 from "./CopySupperDialog.vue?vue&type=style&index=0&id=15379bf5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15379bf5",
  null
  
)

export default component.exports